import React from 'react';

interface ManageTixLogoProps {
  size?: number;
  showText?: boolean;
  className?: string;
}

const ManageTixLogo: React.FC<ManageTixLogoProps> = ({
  size = 40,
  showText = true,
  className = '',
}) => {
  return (
    <div className={`flex items-center ${className}`}>
      {/* Logo Icon */}
      <div
        className="flex items-center justify-center shadow-sm"
        style={{ width: size, height: size }}
      >
        <img
          src="/assets/icon/logo-managetix.png"
          alt="ManageTix Logo"
          className="rounded-lg object-contain"
          style={{ width: size, height: size }}
        />
      </div>

      {/* Logo Text */}
      {showText && (
        <span className="ml-3 text-xl font-bold text-gray-800 dark:text-gray-100">
          ManageTix
        </span>
      )}
    </div>
  );
};

export default ManageTixLogo;
